export function getHiddenFeaturesStorageKey(_user: string): string {
	return `hiddenFeatures_${_user}`;
}

export function parseHiddenFeatureIds(raw: string | null): string[] {
	if (!raw) return [];
	try {
		const parsed = JSON.parse(raw);
		return Array.isArray(parsed)
			? parsed.filter((id): id is string => typeof id === 'string')
			: [];
	} catch {
		return [];
	}
}

export function setFeaturesHidden(
	hiddenIds: string[],
	featureIds: string[],
	hidden: boolean,
): string[] {
	if (hidden) {
		return [...new Set([...hiddenIds, ...featureIds])];
	}
	return hiddenIds.filter((id) => !featureIds.includes(id));
}
